import React, { Fragment, useState, useEffect, useRef } from "react";
import "../../styles/common.css";
import { Outlet } from "react-router-dom";
import TopMenu from "./client-top-menu.jsx";
import logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import { catchError } from '../helpers/catch-error';
import { io } from "socket.io-client";

const Layout = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const socketRef = useRef(null);

 // Single source of truth to manage audit lifecycle and socket connection
    const ensureAuditSession = async () => {
        const userEmail = localStorage.getItem("@user_email");
        const userRole = localStorage.getItem("@user_role");
        let auditId = localStorage.getItem("@audit_id");

        // 1. If basic credentials don't exist, redirect to login
        if (!userEmail || !userRole) {
            localStorage.clear();
            navigate("/login");
            return;
        }

        // 2. If socket is connected and audit_id exists, emit session registration
        if (socketRef.current && socketRef.current.connected && auditId) {
            socketRef.current.emit("register_audit_session", { audit_id: auditId });
            return;
        }

        // 3. Otherwise, fetch a fresh audit_id (handles return visits after 1 hour)
        try {
            const response = await axios.post(
                process.env.REACT_APP_WEB_SERVICES_URL + "/reconnect-audit",
                { email: userEmail, role: userRole ,user_device: navigator.userAgent },
                { withCredentials: true }
            );

            if (response?.data?.status && response?.data?.audit_id) {
                const newAuditId = response.data.audit_id;
                localStorage.setItem("@audit_id", newAuditId);

                const backendUrl = process.env.REACT_APP_WEB_SERVICES_URL;

                // Disconnect existing socket before reconnecting
                if (socketRef.current) {
                    socketRef.current.disconnect();
                }

                socketRef.current = io(backendUrl, {
                    path: "/socket.io/",
                    transports: ["websocket", "polling"],
                    withCredentials: true
                });

                socketRef.current.on("connect", () => {
                  //  console.log("Socket connected with Audit ID:", newAuditId);
                    socketRef.current.emit("register_audit_session", { audit_id: newAuditId });
                });

                socketRef.current.on("connect_error", (err) => {
                    console.warn("Socket connection warning:", err);
                });
            } else {
                // If reconnect fails due to invalid backend session cookie, clear and login
                localStorage.clear();
                navigate("/login");
            }
        } catch (error) {
            console.error("Failed to regenerate audit entry:", error);
            catchError(error, navigate);
        }
    };

    useEffect(() => {
        // Run on component mount
        ensureAuditSession();

        // Run when tab regains focus or becomes visible
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                ensureAuditSession();
            }
        };

        const handleTabClose = () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        };

        window.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("beforeunload", handleTabClose);
        window.addEventListener("pagehide", handleTabClose);

        return () => {
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("beforeunload", handleTabClose);
            window.removeEventListener("pagehide", handleTabClose);
        };
    }, []);


    const handleLogout = async () => {
        setIsBtn(true);

        await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/logout", {
            email: localStorage.getItem('@user_email'),
            audit_id: localStorage.getItem('@audit_id')
        },
        {
            withCredentials: true // 👈 MANDATORY: sends session cookies to Express
        })
            .then(function (response) {
                setIsBtn(false);
                if (response?.data?.status) {
                    // Disconnect active socket session
                    if (socketRef.current) {
                        socketRef.current.disconnect();
                    }

                    localStorage.removeItem("@first_name");
                    localStorage.removeItem("@last_name");
                    localStorage.removeItem("@client_company_name");
                    localStorage.removeItem("@user_role");
                    localStorage.removeItem("@user_email");
                    localStorage.removeItem("@audit_id");
                    navigate("/login");
                } else {
                    Swal.fire({ icon: "error", title: "Logout Failed", text: response?.data?.message });
                }
            })
            .catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate);
            });
    };

    return (
        <Fragment>
            <section className="top" id="top">
                <div className="row">
                    <div className="col">
                        <img src={logo} alt="MedRecAps" className="top-logo" />
                    </div>
                    <div className="col text-end">
                        <span>{localStorage.getItem("@first_name")} </span>| Client | <a href='#' onClick={(e) => { e.preventDefault(); handleLogout(); }} className="text-primary fw-bold">{isBtn ? <span><Loading /> Logging Out</span> : 'Logout'}</a>
                    </div>
                </div>
            </section>
            <section className="top-menu">
                <TopMenu />
            </section>
            <section className="main container-fluid mb-5 ">
                <Outlet />
            </section>
        </Fragment>
    );
};

export default Layout;